<template>
  <div>
    <Header />
    <LoadingDialog
      ref="LoadingDialog"
      message="Please stand by..."
      specific
    />
    <v-container grid-list-md fluid class="container-style">
      <!-- FILTER/SEARCH -->
      <div class="container-header">
        <span>Due Payments</span>
      </div>
      <v-layout row wrap>
        <v-flex xs12>
          <div class="elevation-1">
            <v-toolbar flat color="white">
              <v-layout row wrap justify-end>
                <v-flex xs12 md4 class="box-white">
                  <v-autocomplete
                    v-model="selectedSchoolYear"
                    :items="schoolYears"
                    item-text="name"
                    item-value="id"
                    return-object
                    @change="filterBySchoolYear"
                    color="#091D3B"
                    prepend-inner-icon="date_range"
                    label="School Year"
                    box
                  >
                  </v-autocomplete>
                </v-flex>
                <v-spacer></v-spacer>
                <v-flex xs12 md4 class="box-white">
                  <v-autocomplete
                    v-model="selectedMonth"
                    :items="paymentMonths"
                    return-object
                    @change="filterByMonth"
                    color="#091D3B"
                    prepend-inner-icon="date_range"
                    label="Month"
                    box
                  >
                  </v-autocomplete>
                </v-flex>
              </v-layout>
            </v-toolbar>
            <v-data-table
              v-model="studentTable"
              :headers="headers"
              :items="students"
              :search="search"
              :pagination.sync="pagination"
              item-key="student.full_name"
            >
              <template v-slot:items="props">
                <tr>
                  <td v-if="props.item.student_number_display">
                    {{ props.item.student_number_display }}
                  </td>
                  <td>
                    <router-link :to="{name: 'student-detail', params: {id: props.item.id}}">
                      {{ props.item.full_name }}
                    </router-link>
                  </td>
                  <td>{{dueThisMonth(props.item.selected_enrollment_data.installment_amount)}}</td>
                  <td>{{checkIfPaid(props.item.payments_data, props.item.selected_enrollment_data)}}</td>
                  <td>{{totalPaid(props.item.payments_data, props.item.selected_enrollment_data)}}</td>
                  <td>{{cumulativeBalance(props.item.payments_data, props.item.selected_enrollment_data)}}</td>
                </tr>
              </template>
            </v-data-table>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import {
  mapState,
  mapActions
} from "vuex";

import Header from '@/components/Header.vue'
import LoadingDialog from '@/components/LoadingDialog.vue'

export default {
  name: "DuePayments",
  components: {
    Header,
    LoadingDialog,
  },
  computed: {
    ...mapState(['schoolYears', 'students']),
  },
  data() {
    return {
      monthly: {'July': 6, 'August': 7, 'September': 8, 'October': 9, 'November': 10, 'December': 11, 'January': 0, 'February': 1, 'March': 2},
      quarterly: {'July': 6, 'September': 8, 'December': 11, 'March': 2},
      paymentPlan: [],
      search: '',
      paymentAmount: null,
      studentTable: [],
      pagination: {
        rowsPerPage: 25,
        sortBy: 'student_number_display'
      },
      selectedSchoolYear: null,
      selectedMonth: null,
      paymentMonths: [
        {
          value: 1,
          month: 5,
          text: 'June',
          year: this.$moment().year()},
        {
          value: 2,
          month: 6,
          text: 'July',
          year: this.$moment().year()},
        {
          value: 3,
          month: 7,
          text: 'August',
          year: this.$moment().year()},
        {
          value: 4,
          month: 8,
          text: 'September',
          year: this.$moment().year()},
        {
          value: 5,
          month: 9,
          text: 'October',
          year: this.$moment().year()},
        {
          value: 6,
          month: 10,
          text: 'November',
          year: this.$moment().year()},
        {
          value: 7,
          month: 11,
          text: 'December',
          year: this.$moment().year()},
        {
          value: 8,
          month: 0,
          text: 'January',
          year: this.$moment().year() + 1},
        {
          value: 9,
          month: 1,
          text: 'February',
          year: this.$moment().year() + 1},
        {
          value: 10,
          month: 2,
          text: 'March',
          year: this.$moment().year() + 1},
        {
          value: 11,
          month: 3,
          text: 'April',
          year: this.$moment().year() + 1},
        {
          value: 12,
          month: 4,
          text: 'May',
          year: this.$moment().year() + 1},
      ],
      headers: [
        {
          text: 'Student Number',
          value: 'student_number_display',
          width: '10%'
        },
        {
          text: 'Full Name',
          value: 'full_name',
          width: '20%'
        },
        {
          text: 'Due this Month',
          value: 'selected_enrollment_data.installment_amount',
          width: '20%'
        },
        {
          text: 'Paid this month?',
          value: '',
          width: '15%'
        },
        {
          text: 'Total Payments',
          value: '',
          width: '15%'
        },
        {
          text: 'Cumulative Balance',
          value: 'birthday',
          width: '10%'
        },
      ],
    }
  },
  methods: {
    ...mapActions(['getSchoolYears', 'getStudentsByDueMonth',]),
    dueThisMonth(amount) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'PHP',
        minimumFractionDigits: 2,
      });
      return formatter.format(amount)
    },
    getActiveSchoolYear() {
      this.schoolYears.some((schoolYear) => {
        if (schoolYear.is_open) {
          this.selectedSchoolYear = schoolYear;
          return true
        }
      })
    },
    totalPaid (payments_data, enrollment_data) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'PHP',
        minimumFractionDigits: 2,
      });
      let payment_amount = 0
      for (let payment in payments_data) {
        if (this.$moment(payments_data[payment].collected_date).year() < this.selectedMonth.year) {
          if (this.$moment(payments_data[payment].collected_date).month() <= this.selectedMonth.value && payments_data[payment].amount == enrollment_data.installment_amount) {
            payment_amount += parseInt(payments_data[payment].amount)
          }
        } else if (this.$moment(payments_data[payment].collected_date).year() == this.selectedMonth.year) {
          if (this.$moment(payments_data[payment].collected_date).month() <= this.selectedMonth.month && payments_data[payment].amount == enrollment_data.installment_amount) {
            payment_amount += parseInt(payments_data[payment].amount)
          }
        }
      }
      return (formatter.format(parseFloat(payment_amount)))
    },
    cumulativeBalance (payments_data, enrollment_data) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'PHP',
        minimumFractionDigits: 2,
      });
      let payment_amount = 0
      for (let payment in payments_data) {
        if (this.$moment(payments_data[payment].collected_date).year() < this.selectedMonth.year) {
          if (this.$moment(payments_data[payment].collected_date).month() <= this.selectedMonth.value && payments_data[payment].amount == enrollment_data.installment_amount) {
            payment_amount += parseInt(payments_data[payment].amount)
          }
        } else if (this.$moment(payments_data[payment].collected_date).year() == this.selectedMonth.year) {
          if (this.$moment(payments_data[payment].collected_date).month() <= this.selectedMonth.month && payments_data[payment].amount == enrollment_data.installment_amount) {
            payment_amount += parseInt(payments_data[payment].amount)
          }
        }
      }
      return (formatter.format((parseFloat(enrollment_data.installment_amount) * enrollment_data.num_installments) - parseFloat(payment_amount)))
    },
    checkIfPaid (payments_data, enrollment_data) {
      if (payments_data.length > 0) {
        let paidMonths = {}
        for (let payment in payments_data) {
          if (this.$moment(payments_data[payment].collected_date).year() == this.selectedMonth.year) {
            if (this.$moment(payments_data[payment].collected_date).month() <= this.selectedMonth.month && payments_data[payment].amount == enrollment_data.installment_amount) {
              paidMonths[this.$moment(payments_data[payment].collected_date).month()] = payments_data[payment].amount
            }
          }
        }
        if (this.selectedMonth.month in paidMonths) {
          return "Yes"
        } else {
          return "No"
        }
      } else {
        return "No"
      }
    },
    getCurrentMonth() {
      this.paymentMonths.some((month) => {
        if (month.month == this.$moment().month()) {
          this.selectedMonth = month
          if (month.text == "November") {
            this.paymentPlan = [1,2,3]
          } else if (month.text in  this.quarterly) {
            this.paymentPlan = [1,2]
          } else if (month.text in  this.monthly) {
            this.paymentPlan = [1]
          } else {
            this.paymentPlan = []
          }
          return true
        }
      })
    },
    getStudent() {
      this.getStudentsByDueMonth({schoolYear: this.selectedSchoolYear, paymentPlan: this.paymentPlan})
        .then((data) => {
          this.$refs.LoadingDialog.dialog = false
        })
        .catch((errors) => {
          this.$toastr('info', 'No Payments Due this month', 'Info');
          this.$refs.LoadingDialog.dialog = false
        })
    },
    filterBySchoolYear() {
      this.$refs.LoadingDialog.dialog = true
      this.getStudent()
    },
    filterByMonth() {
        if (this.selectedMonth.text == "November") {
          this.paymentPlan = [1,2,3]
        } else if (this.selectedMonth.text in  this.quarterly) {
          this.paymentPlan = [1,2]
        } else if (this.selectedMonth.text in  this.monthly) {
          this.paymentPlan = [1]
        } else {
          this.paymentPlan = []
        }
        this.$refs.LoadingDialog.dialog = true
        this.getStudent()
    },
  },
  created () {
  },
  mounted () {
    this.$refs.LoadingDialog.dialog = true
    this.getCurrentMonth()
    this.getSchoolYears()
      .then((data) => {
        this.getActiveSchoolYear() // <-- this is synchronous
        this.getStudent()
      })
  },
}
</script>
